import { STORE } from "stores/store";

/**
 * 入力値の取得
 * @param {Object} state useStateMachineから自動で渡される。storeに保存された値
 */
export const getStore = (state, _) => {
  return {
    ...state,
  };
};

/** ご希望日時 */
export const appointmentAction = (state, payload) => {
  return {
    ...state,
    storeAppointment: {
      ...payload,
    },
  };
};

/** カレンダー */
export const appointmentCalendarAction = (state, payload) => {
  return {
    ...state,
    appointmentCalendar: {
      ...payload,
    },
  };
};

/** 機器選択 */
export const kikiSelectAction = (state, payload) => {
  return {
    ...state,
    storeKikiSelect: {
      ...payload,
    },
  };
};

/** お客さま情報入力 */
export const contractAction = (state, payload) => {
  return {
    ...state,
    storeContract: {
      ...payload,
    },
  };
};

/** 確認画面 */
export const confirmAction = (state, payload) => {
  return {
    ...state,
    storeConfirm: {
      ...payload,
    },
  };
};

/**
 * myTOKYOGASログイン後のコールバック画面のAPI返却値を更新
 * @param {Object} state useStateMachineから自動で渡される。storeに保存された値
 * @param {Object} payload useStateMachineから自動で渡される。onSubmitされた値
 */
export const mtgCallbackUpdateAction = (state, payload) => {
  return {
    ...state,
    mtgCallback: {
      ...payload,
    },
  };
};

/**
 * storeをクリア
 *
 * @param {Object} state useStateMachineから自動で渡される。storeに保存された値
 * @param {Object} payload useStateMachineから自動で渡される。onSubmitされた値
 */
export const resetStore = (state) => {
  return {
    ...state,
    ...STORE,
  };
};
